import React, { useEffect, useState } from 'react'
import { Modal } from 'react-bootstrap'
import {
    responseGet, globalSettings, dateTimeFormatGlobalSet, separatorsNumbersSet, sendMessageCloseCurrentWindowAsync, languageObjGet, isUndNullEmp, styles,
    awaitDelay
} from '../../helpers/settings'
import { collectionCashModelGet } from '../../models/collections/collectionCash';
import { collectionCashMovementModelGet } from '../../models/collections/collectionCashMovement';
import { userModelGet } from '../../models/users/user';
import { GlobalFormats } from '../../classes/main/globalFormats';
import { purchaseModelGet } from '../../models/expenses/purchase';
import { supplierModelGet } from '../../models/expenses/suppliers';

const { collections: dbColle, icons, labels, } = globalSettings;

const currentMethod = 'CollectionCashMovementDetails';
const neutralValue = 0.00;
const neutralValueStr = separatorsNumbersSet({
    number: neutralValue,
    withDecimals: true,
    consoleLogErrorShow: true,
    subMethod: currentMethod,
})?.result;

export default function CollectionCashMovementDetails({
    $ = {},
    auth = {},
    collectionCashMovement = {
        collection: '',
        collectionCash: collectionCashModelGet({}),
        collectionCashMovement: collectionCashMovementModelGet({}),
        movement: collectionCashMovementModelGet({}),
        userConciliation: userModelGet({}),
        purchase: {
            details: [],
            purchase: purchaseModelGet({}),
            supplier: supplierModelGet({}),
        },
    },
    showModal = false,
    setShowModal = () => { },
    languageObj = GlobalFormats?.class(languageObjGet({ subMethod: currentMethod, })?.result),
}) {
    //#region variable
    const chkReconcileId = 'chkReconcile';
    const [movementType, setMovementType] = useState(0);
    const [movementDate, setMovementDate] = useState('');
    const [controlNumber, setControlNumer] = useState('');
    const [movementOrigin, setMovementOrigin] = useState('');
    const [movementAmount, setMovementAmount] = useState('');
    const [concilationUser, setConcilationUser] = useState('');
    const [supplier, setSupplier] = useState(supplierModelGet({}));
    const [concilationRemark, setConcilationRemark] = useState('');
    const [movementReference, setMovementReference] = useState('');
    const [movementCollection, setMovementCollection] = useState('');
    const [movementOriginDate, setMovementOriginDate] = useState('');
    const [movementOriginNumber, setMovementOriginNumber] = useState('');
    const [movementOriginDocument, setMovementOriginDocument] = useState('');
    const [movementTypeDescription, setMovementTypeDescription] = useState('');
    const [concilationMovementDate, setConcilationMovementDate] = useState('');
    //#endregion variable

    //#region others
    const controls = {
        buttons: {
            back: {
                id: 'btnMovementModalBack',
                className: 'btn btn-outline-success',
            },
            close: {
                id: 'btnMovementModalClose',
                className: 'close btn-danger fas fa-window-close',
            },
        },
        dataTables: {
            // movements: {
            //     buttons: {
            //         // detailAdd: {
            //         //     className: 'btn btn-sm btn-outline-info mx-1 float-right',
            //         //     id: 'btnDtPurchaseDetailsIdDetailAdd',
            //         // },
            //     },
            //     icons: {
            //         // detailAdd: {
            //         //     id: 'iconDtPurchaseDetailsIdDetailAdd',
            //         //     className: icons?.list,
            //         // },
            //     },
            //     inputs: {
            //         search: {
            //             id: `${dtMovementsId}_filter input`,
            //             className: '',
            //         },
            //     },
            //     selects: {
            //         entries: {
            //             id: `${dtMovementsId}_length select`,
            //             className: '',
            //         },
            //     },
            //     // spinners: {
            //     //     detailAdd: {
            //     //         id: 'spDtPurchaseDetailsIdDetailAdd',
            //     //         className: '',
            //     //     },
            //     // },
            // },
        },
        icons: {
            back: {
                id: 'icoMovementModalBack',
                className: icons?.arrowCircleLeft,
            },
            close: {
                id: 'icoMovementModalClose',
                className: '',
            },
        },
        inputs: {
            // date: {
            //     id: 'inputMovementModalDate',
            //     className: 'form-control bg-transparent text-black',
            // },
        },
        radioButtons: {
            // all: {
            //     id: 'rButonAll',
            //     className: 'icheck-primary d-inline',
            //     name: 'radioButtonName',
            // },
        },
        selects: {
            // type: {
            //     id: 'selMovementModalType',
            //     className: 'form-select',
            // },
        },
        spinners: {
            back: {
                id: 'spMovementModalBack',
                className: '',
            },
            close: {
                id: 'spMovementModalClose',
                className: '',
            },
        },
    };
    //#endregion others

    //#region methods
    const dataGetAsync = async ({
        subMethod = '',
    }) => {
        const currentMethod = 'dataGetAsync';
        let response = responseGet();
        try {
            //#region variables
            let movementTypeLocal = 0;
            let momeventDateLocal = '';
            let momeventConcilationDateLocal = '';
            let movementCollectionLocal = collectionCashMovement?.collection || '';
            const dateTimeObj = {
                format: languageObj?.format?.date?.f1,
                //time: languageObj?.format?.time?.type,
                time: 0,
            };
            //#endregion variables

            //#region validations
            //#region movementType
            movementTypeLocal = !isUndNullEmp({ data: movementCollectionLocal, subMethod: currentMethod, })?.result ?
                movementCollectionLocal === dbColle?.apartmentReceiptPayments ?
                    1 :
                    movementCollectionLocal === dbColle?.purchasePayments ?
                        -1 :
                        movementCollectionLocal === dbColle?.collectionCashMovements && !isUndNullEmp({ data: collectionCashMovement?.movement?.type, subMethod: currentMethod, })?.result ?
                            collectionCashMovement?.movement?.type === 'I' ? 1 : -1 :
                            0 :
                0;
            //#endregion movementType

            if (movementTypeLocal !== 0) {
                momeventDateLocal = dateTimeFormatGlobalSet({
                    date: collectionCashMovement?.movement?.date,
                    type: dateTimeObj?.format,
                    format: dateTimeObj?.time,
                    addTime: false,
                    secondsShow: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                })?.result;
            }

            if (movementTypeLocal === 1) {
                if (!isUndNullEmp({ data: collectionCashMovement?.movement?.concilationStatus, subMethod: currentMethod, })?.result &&
                    collectionCashMovement?.movement?.concilationStatus === 'S') {
                    momeventConcilationDateLocal = dateTimeFormatGlobalSet({
                        date: collectionCashMovement?.movement?.concilationDate,
                        type: dateTimeObj?.format,
                        format: dateTimeObj?.time,
                        addTime: false,
                        secondsShow: false,
                        languageId: languageObj?.id,
                        subMethod: currentMethod,
                    })?.result;
                }

                setMovementOrigin(
                    movementCollectionLocal === dbColle?.collectionCashMovements ?
                        `${labels?.collectionCash?.[languageObj?.id]} (${labels?.movement?.[languageObj?.id]?.toLowerCase()})` :
                        labels?.apartment?.[languageObj?.id]
                );

                setMovementOriginNumber(
                    !isUndNullEmp({ data: collectionCashMovement?.apartment, subMethod: currentMethod, })?.result &&
                        !isUndNullEmp({ data: collectionCashMovement?.apartment?.identifier, subMethod: currentMethod, })?.result ?
                        collectionCashMovement?.apartment?.identifier :
                        ''
                );

                setMovementOriginDocument(
                    !isUndNullEmp({ data: collectionCashMovement?.apartmentReceipt, subMethod: currentMethod, })?.result &&
                        !isUndNullEmp({ data: collectionCashMovement?.apartmentReceipt?.receiptNumberApartment, subMethod: currentMethod, })?.result ?
                        collectionCashMovement?.apartmentReceipt?.receiptNumberApartment :
                        ''
                );

                setMovementOriginDate(
                    dateTimeFormatGlobalSet({
                        date: collectionCashMovement?.apartmentReceipt?.created,
                        type: languageObj?.format?.date?.f1,
                        format: 0,
                        addTime: false,
                        secondsShow: false,
                        languageId: languageObj?.id,
                        subMethod: currentMethod,
                    })?.result
                );
            } else if (movementTypeLocal === -1) {
                setMovementOrigin(
                    movementCollectionLocal === dbColle?.collectionCashMovements ?
                        labels?.movement?.[languageObj?.id] :
                        labels?.purchase?.[languageObj?.id]
                );

                setMovementOriginDocument(collectionCashMovement?.purchase?.purchase?.number || '');
                setControlNumer(collectionCashMovement?.purchase?.purchase?.invoiceControlNumber || '');
                setMovementOriginNumber(collectionCashMovement?.purchase?.purchase?.invoiceNumber || '');
                setSupplier(collectionCashMovement?.purchase?.supplier || {});
                setMovementOriginDate(
                    dateTimeFormatGlobalSet({
                        date: collectionCashMovement?.purchase?.purchase?.date,
                        type: languageObj?.format?.date?.f1,
                        format: 0,
                        addTime: false,
                        secondsShow: false,
                        languageId: languageObj?.id,
                        subMethod: currentMethod,
                    })?.result
                );
            }


            if (!isUndNullEmp({ data: collectionCashMovement?.userConciliation?.firstName, subMethod: currentMethod, })?.result ||
                !isUndNullEmp({ data: collectionCashMovement?.userConciliation?.lastName, subMethod: currentMethod, })?.result) {
                setConcilationUser(`${collectionCashMovement?.userConciliation?.firstName || ''}, ${collectionCashMovement?.userConciliation?.lastName || ''}`);
            }

            if (!isUndNullEmp({ data: collectionCashMovement?.movement, subMethod: currentMethod, })?.result &&
                !isUndNullEmp({ data: collectionCashMovement?.movement?.created, subMethod: currentMethod, })?.result) {
                momeventConcilationDateLocal = dateTimeFormatGlobalSet({
                    date: collectionCashMovement?.movement?.created,
                    type: dateTimeObj?.format,
                    format: 0,
                    addTime: false,
                    secondsShow: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                })?.result;
            }
            //#endregion validations

            //#region data set
            setMovementReference(
                !isUndNullEmp({ data: collectionCashMovement?.movement?.reference, subMethod: currentMethod, })?.result ?
                    collectionCashMovement?.movement?.reference :
                    !isUndNullEmp({ data: collectionCashMovement?.movement?.remark, subMethod: currentMethod, })?.result ?
                        collectionCashMovement?.movement.remark :
                        ''
            );

            setMovementAmount(
                !isUndNullEmp({ data: collectionCashMovement?.movement?.amount, subMethod: currentMethod, })?.result ?
                    separatorsNumbersSet({
                        number: movementTypeLocal !== 0 ?
                            collectionCashMovement?.movement?.amount * movementTypeLocal :
                            collectionCashMovement?.movement?.amount,
                        withDecimals: true,
                        consoleLogErrorShow: true,
                        subMethod: currentMethod,
                    })?.result :
                    neutralValueStr
            );

            setConcilationRemark(
                !isUndNullEmp({ data: collectionCashMovement?.movement?.conciliationRemark, subMethod: currentMethod, })?.result ?
                    collectionCashMovement?.movement.conciliationRemark :
                    ''
            );

            setMovementType(movementTypeLocal);
            setMovementDate(momeventDateLocal);
            setMovementCollection(movementCollectionLocal);
            setConcilationMovementDate(momeventConcilationDateLocal);
            setMovementTypeDescription(movementTypeLocal === 1 ? labels?.income?.[languageObj?.id] : (movementTypeLocal === -1 ? labels?.egress?.[languageObj?.id] : ''));
            //#endregion data set
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
    }

    const defaultValueSetAsync = async ({
        isModalClose = false,
        subMethod = '',
    }) => {
        const currentMethod = 'defaultValueSetAsync';
        let response = responseGet();
        try {
            if (isModalClose) {
                controlsStatusSet({ processType: 0, subMethod: currentMethod, });
                controlsStatusSet({ processType: 2, subMethod: currentMethod, });
                await awaitDelay({ delayTimer: globalSettings?.timers?.oneSecond, });
                controlsStatusSet({ processType: 0, subMethod: currentMethod, });
            }

            setShowModal(!isModalClose);
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
    }

    const controlsStatusSet = ({ processType = 0, subMethod = '', }) => {
        let response = responseGet();
        const currentMethod = 'controlsStatusSet';
        try {
            //#region variables
            //#endregion variables

            //#region methods
            switch (processType) {
                case 0:
                    for (let ctrStr in controls) {
                        const objStr = ['buttons', 'spinners', 'icons'];
                        if (objStr?.includes(ctrStr)) {
                            for (let propStr in controls?.[ctrStr]) {
                                $(`#${controls?.[ctrStr]?.[propStr]?.id}`)?.removeClass();
                                $(`#${controls?.[ctrStr]?.[propStr]?.id}`)?.addClass(controls?.[ctrStr]?.[propStr]?.className);
                            }
                        }
                    }
                    break;
                case 1:
                    //$(`#${controls?.buttons?.create?.id}`)?.addClass(`${globalSettings?.react?.html?.button?.classes?.disabled} ${settings.react.html.button.classes.progress}`);
                    // $(`#${controls?.icons?.save?.id}`)?.removeClass();
                    // $(`#${controls?.spinners?.save?.id}`)?.addClass(`${globalSettings?.react?.html?.spinner?.borderSm}`);
                    break;
                case 2:
                    $(`#${controls?.icons?.back?.id}`)?.removeClass();
                    $(`#${controls?.spinners?.back?.id}`)?.addClass(`${globalSettings?.react?.html?.spinner?.borderSm}`);
                    break;
                default:
                    break;
            }

            //#region controls
            // $(`#${controls?.inputs?.date?.id}`).attr({ readOnly: (processType !== 0), });
            // $(`#${controls?.selects?.type?.id}`).attr({ disabled: (processType !== 0), });
            // $(`#${controls?.inputs?.amount?.id}`).attr({ readOnly: (processType !== 0), });
            // $(`#${controls?.inputs?.remark?.id}`).attr({ readOnly: (processType !== 0), });
            //#endregion controls

            //#region old code
            // $(`#${controls?.urls?.forgotYourPassword?.id}`).attr('href', (processType !== 0 ? urlStop : backend?.urlForgotPassword));
            // $(`#${controls?.urls?.userRegister?.id}`).attr('href', (processType !== 0 ? urlStop : backend?.urlUserRegister));
            // $(`#${controls?.urls?.registerStatus?.id}`).attr('href', (processType !== 0 ? urlStop : backend?.urlRegisterStatus));
            //#endregion old code

            //#region old code
            // $(`#${controls?.urls?.reCaptchaPrivaciConditions?.id}`).attr('href', (processType !== 0 ? urlStop : globalSettings?.react?.reCAPTCHA?.urlPrivaciConditions));
            // $(`#${controls?.urls?.reCaptchaPrivaciConditions?.id}`).attr('target', (processType !== 0 ? '' : '_blank'));
            //#endregion old code

            //#region old code
            // $(`#${controls?.urls?.reCaptchaPrivaciConditions?.id}`).attr({
            //     'href': (processType !== 0 ? urlStop : globalSettings?.app?.reCAPTCHA?.urlPrivaciConditions),
            //     'target': (processType !== 0 ? '' : '_blank'),
            // });
            //#endregion old code

            //#region dataTable buttons
            // btnExcel.node.disabled = processType !== 0;
            // btnPdf.node.disabled = processType !== 0;
            //#endregion dataTable buttons

            // $(`#${controls?.dataTables?.movements?.inputs?.search?.id}`)?.attr('readOnly', (processType !== 0));
            // $(`#${controls?.dataTables?.movements?.selects?.entries?.id}`)?.attr('disabled', (processType !== 0));

            if (processType !== 0) {
                //$(`#${controls?.buttons?.save?.id}`)?.addClass(`${globalSettings?.react?.html?.button?.classes?.disabled}`);
                $(`#${controls?.buttons?.back?.id}`)?.addClass(`${globalSettings?.react?.html?.button?.classes?.disabled}`);
                $(`#${controls?.buttons?.close?.id}`)?.addClass(`${globalSettings?.react?.html?.button?.classes?.disabled}`);
            }
            //#endregion methods
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
            console?.error(response);
        }
        return response;
    }

    useEffect(() => {
        dataGetAsync({
            subMethod: 'from - onLoad',
        });
    }, [showModal]) //eslint-disable-line react-hooks/exhaustive-deps
    //#endregion methods

    return (
        <Modal backdrop='static' onHide={() => defaultValueSetAsync({ isModalClose: true, subMethod: 'form - onHide', })} show={showModal}>
            <Modal.Header>
                <Modal.Title>
                    <img alt={labels?.movement?.[languageObj?.id]}
                        style={styles?.cardHeaderLogo}
                        src={globalSettings?.images?.movementsLogo}>
                    </img> - {labels?.movement?.[languageObj?.id]} ({labels?.detail?.[languageObj?.id]?.toLowerCase()})
                </Modal.Title>
                <button id={controls?.buttons?.close?.id}
                    className={controls?.buttons?.close?.className}
                    type='button'
                    data-dismiss='modal'
                    aria-label='Close'
                    onClick={() => defaultValueSetAsync({ isModalClose: true, subMethod: 'form - btnClose', })}>
                </button>
            </Modal.Header>
            <Modal.Body>
                {/* <div className='card shadow-lg'> */}
                {/* <div className='card-body'> */}

                <div>
                    <div className='row text-muted'>
                        <div className='col-md-4'>
                            {labels?.type?.[languageObj?.id]}:
                        </div>
                        <div className={`col-md-8 ${movementType === -1 ? 'text-danger' : 'text-success'}`}>
                            <b>{movementTypeDescription}</b>
                        </div>
                    </div>

                    <div className='row text-muted'>
                        <div className='col-md-4'>
                            {labels?.date?.[languageObj?.id]}:
                        </div>
                        <div className='col-md-8'>
                            <b>{movementDate} </b>
                        </div>
                    </div>

                    <div className='row text-muted'>
                        <div className='col-md-4'>
                            {labels?.reference?.[languageObj?.id]}:
                        </div>
                        <div className='col-md-8'>
                            <b>{movementReference}</b>
                        </div>
                    </div>

                    <div className='row text-muted'>
                        <div className='col-md-4'>
                            {labels?.amount?.[languageObj?.id]}:
                        </div>
                        <div className='col-md-8'>
                            <b>{movementAmount}</b>
                        </div>
                    </div>

                    <hr />

                    <div className='row text-muted'>
                        <div className='col-md-4'>
                            {labels?.origin?.[languageObj?.id]}:
                        </div>
                        <div className='col-md-8'>
                            <b>{movementOrigin} </b>
                        </div>
                    </div>

                    {!isUndNullEmp({ data: movementCollection, subMethod: currentMethod, })?.result &&
                        movementCollection !== dbColle?.collectionCashMovements ?
                        <div>
                            <div className='row text-muted'>
                                <div className='col-md-4'>
                                    {movementType === 1 ? labels?.receipt?.[languageObj?.id] : (movementType === -1 ? labels?.number?.[languageObj?.id] : '')}:
                                </div>
                                <div className='col-md-8'>
                                    <b>{movementOriginDocument} </b>
                                </div>
                            </div>

                            <div className='row text-muted'>
                                <div className='col-md-4'>
                                    {movementCollection === dbColle?.purchasePayments ? labels?.purchase?.[languageObj?.id] : labels?.identifier?.[languageObj?.id]}:
                                </div>
                                <div className='col-md-8'>
                                    <b>{movementOriginNumber} </b>
                                </div>
                            </div>

                            {movementCollection === dbColle?.purchasePayments ?
                                <div>
                                    <div className='row text-muted'>
                                        <div className='col-md-4'>
                                            {labels?.controlNumber?.[languageObj?.id]}:
                                        </div>
                                        <div className='col-md-8'>
                                            <b>{controlNumber} </b>
                                        </div>
                                    </div>
                                    <div className='row text-muted'>
                                        <div className='col-md-4'>
                                            {labels?.supplier?.[languageObj?.id]}:
                                        </div>
                                        <div className='col-md-8'>
                                            <b>{supplier?.description || ''} </b>
                                        </div>
                                    </div>
                                </div>
                                :
                                <></>
                            }

                            <div className='row text-muted'>
                                <div className='col-md-4'>
                                    {labels?.date?.[languageObj?.id]}:
                                </div>
                                <div className='col-md-8'>
                                    <b>{movementOriginDate} </b>
                                </div>
                            </div>
                        </div>
                        :
                        <></>
                    }

                    <hr />

                </div>

                {movementType === 1 || movementType === -1 ?
                    <div>
                        {!isUndNullEmp({ data: movementCollection, subMethod: currentMethod, })?.result &&
                            movementCollection !== dbColle?.collectionCashMovements ?
                            <div className='row text-muted'>
                                <div className='col-md-4'>
                                    {labels?.reconcilied?.[languageObj?.id]}:
                                </div>
                                <div className='col-md-8'>
                                    <div className='icheck-primary d-inline'>
                                        <input
                                            checked
                                            id={chkReconcileId}
                                            readOnly
                                            type='checkbox' />
                                        <label htmlFor={chkReconcileId}></label>
                                    </div>
                                </div>
                            </div>
                            :
                            <></>
                        }

                        <div className='row text-muted'>
                            <div className='col-md-4'>
                                {labels?.date?.[languageObj?.id]}:
                            </div>
                            <div className='col-md-8'>
                                <b>{concilationMovementDate}</b>
                            </div>
                        </div>

                        {!isUndNullEmp({ data: movementCollection, subMethod: currentMethod, })?.result &&
                            movementCollection !== dbColle?.collectionCashMovements ?
                            <div className='row text-muted'>
                                <div className='col-md-4'>
                                    {labels?.remark?.[languageObj?.id]}:
                                </div>
                                <div className='col-md-8'>
                                    <b>{concilationRemark}</b>
                                </div>
                            </div>
                            :
                            <></>
                        }
                    </div>
                    :
                    <></>
                }

                <div className='row text-muted'>
                    <div className='col-md-4'>
                        {labels?.user?.[languageObj?.id]}:
                    </div>
                    <div className='col-md-8'>
                        <b>{concilationUser}</b>
                    </div>
                </div>

                {/* </div> */}

                {/* <div className='card-footer'>
                        <div className='form-group text-right'>
                            <button className='btn btn-outline-success'
                                tooltip='tooltip'
                                title={labels?.close?.[languageObj?.id]}
                                type='reset'
                                onClick={() => defaultValueSetAsync(true)}>
                                <i className={icons?.arrowCircleLeft}></i>
                            </button>
                        </div>
                    </div> */}
                {/* </div> */}
            </Modal.Body>
            <Modal.Footer>
                <div className='form-group text-right'>
                    <button id={controls?.buttons?.back?.id}
                        className={controls?.buttons?.back?.className}
                        tooltip='tooltip'
                        title={labels?.close?.[languageObj?.id]}
                        type='reset'
                        onClick={() => defaultValueSetAsync({ isModalClose: true, subMethod: 'form - btnBack', })}>
                        <i id={controls?.icons?.back?.id} className={controls?.icons?.back?.className} /> <span id={controls?.spinners?.back?.id} className='' aria-hidden='true'></span>
                    </button>
                </div>
            </Modal.Footer>
        </Modal>
    )
}